import React, { useState } from 'react';
import styled from 'styled-components';
import { TEXT_KEY, getText } from 'shared/utils/localization';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import Button from '../../../../../components/Button/Button';
import { isNotStandaloneMobilePWA } from '../../../../../utils/mobileSupported';
import { isMobile, isTablet } from 'react-device-detect';

const InviteScreen = props => {
  const { friendsInviteFeatureState, friendsInviteAssets } = props;

  const [isLinkCopied, setIsLinkCopied] = useState(false);
  const [showInviteLink, setShowInviteLink] = useState(false);

  const copyInviteLink = () => {
    navigator.clipboard.writeText(friendsInviteFeatureState?.inviteLink?.inviteLinkUrl);
    setIsLinkCopied(true);
  };

  return (
    <Container {...props}>
      <TitleImage src={friendsInviteAssets?.SOCIAL_FRIENDS_MORE_COINS_TITLE} />
      <Body>
        <Description isInviteLink={showInviteLink}>
          {!showInviteLink
            ? getText(TEXT_KEY.SOCIAL_INVITE_SCREEN_DESCRIPTION)
            : getText(TEXT_KEY.SOCIAL_INVITE_SCREEN_DESCRIPTION_WEB)}
        </Description>
        {!showInviteLink ? (
          <Button
            onClick={() => setShowInviteLink(true)}
            imageSource={assetSource(ASSET_KEY.ROUNDED_RECT_PRIMARY)}
            label={getText(TEXT_KEY.SOCIAL_INVITE_SCREEN_BUTTON)}
            containerStyle={ButtonStyle}
          />
        ) : (
          <InviteLink onClick={copyInviteLink}>{friendsInviteFeatureState?.inviteLink?.inviteLinkUrl}</InviteLink>
        )}
        {isLinkCopied && <CopiedLink>{getText(TEXT_KEY.SOCIAL_INVITE_SCREEN_LINK_COPIED)}</CopiedLink>}
        <Footer>{getText(TEXT_KEY.SOCIAL_INVITE_SCREEN_FOOTER)}</Footer>
      </Body>
      <BottomImage src={friendsInviteAssets?.SOCIAL_FRIENDS_CHARACTERS_IMAGE} showInviteLink={showInviteLink} />
    </Container>
  );
};

export default InviteScreen;

const Container = styled.div`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  opacity: ${({ isGuestUser, hasActiveState }) => (isGuestUser || !hasActiveState ? 0.1 : 1)};
  display: ${({ limitReached, friendsInviteAssets }) => (limitReached || !friendsInviteAssets ? 'none' : 'flex')};
`;

const TitleImage = styled.img`
  width: 100%;
  height: 10rem;
  object-fit: contain;
  position: relative;
  top: 1rem;
`;

const Body = styled.div`
  width: 100%;
  height: 55%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  padding-left: 1.8rem;
  padding-right: 1.8rem;
`;

const Description = styled.p`
  font-size: 1.2rem;
  color: white;
  text-align: center;
  margin-top: ${({ isInviteLink }) => (isInviteLink && isNotStandaloneMobilePWA ? '2rem' : '0px')};
  font-weight: 700;
  width: ${({ isInviteLink }) => (isInviteLink ? '100%' : isTablet ? '70%' : '45%')};
`;

const InviteLink = styled.p`
  font-size: 1.2rem;
  color: white;
  text-align: center;
  font-weight: 700;
  cursor: pointer;
`;

const CopiedLink = styled.p`
  font-size: 0.9rem;
  color: white;
  text-align: center;
  position: absolute;
  top: ${isMobile && !isTablet ? 23.7 : 25}rem;
`;

const Footer = styled.p`
  font-size: 0.8rem;
  color: white;
  text-align: center;
`;

const BottomImage = styled.img`
  height: 20vh;
  width: 40rem;
  ${!isTablet && `height: ${({ showInviteLink }) => (showInviteLink ? 20 : 25)}rem`};
  object-fit: contain;
  position: relative;
  top: 1vh;
`;

const ButtonStyle = {
  marginTop: '1rem',
  marginBottom: isNotStandaloneMobilePWA ? '1.5rem' : '2rem',
};

